import { CustomerEffects } from './customer.effect';

export const effects: any[] = [CustomerEffects];

export * from './customer.effect';
